<template>
  <div class="Experience flex-jc-bt">
    <div class="flex-1 left-side">
      <sp-card custom-class="sp-color-bg-4">
        <el-table
          align="center"
          class="cus-el-table"
          max-height="500"
          :data="dataList"
          style="width: 100%"
          :row-style="setTdHei"
          row-key="id"
          border
        >
          <el-table-column align="center" header-align="center" prop="date" min-width="180" :label="$l('CompanyCityCountry')">
            <template #default="scope">
              <div class="text-center">
                <p class="item-p sp-color-11">{{ scope.row.department?.companies?.sub?.name }}</p>
                <p v-if="scope.row.department?.companies?.sub?.nativeName" class="item-p sp-color-7">{{ scope.row.department?.companies?.sub?.nativeName }}</p>
                <p class="item-p sp-color-7">
                  {{ scope.row.department?.companies?.sub?.regCity?.name }} <span v-if="scope.row.department?.companies?.sub?.regCity?.name">,
                  </span> {{ scope.row.department?.companies?.sub?.regCountry?.name }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column header-align="center" min-width="150" prop="date" :label="$l('DeptCityCountry')">
            <template #default="scope">
              <div class="text-center">
                <p class="item-p sp-color-11">{{ scope.row.department?.name }}</p>
                <p v-if="scope.row.department?.nativeName" class="item-p sp-color-7">{{ scope.row.department?.nativeName }}</p>
                <p class="item-p sp-color-7">
                  {{ scope.row.department?.city?.name }} <span v-if="scope.row.department?.city?.name">,
                  </span> {{ scope.row.department?.country?.name }}
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column header-align="center" prop="date" min-width="120" :label="$l('Responsibilies')">
            <template #default="scope">
              <p class="item-p sp-color-11 text-center">{{ scope.row.job.profession?.name }}</p>
            </template>
          </el-table-column>
          <el-table-column header-align="center" prop="date" :label="$l('Position')">
            <template #default="scope">
              <p class="item-p sp-color-11 text-center">{{ scope.row.job.position?.name }}</p>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" prop="date" min-width="120" :label="$l('Job Description')">
            <template #default="scope">
              <p class="ellipsis-3 item-p sp-color-11 text-center" :title="scope.row.job?.description">
                {{ scope.row.job?.description }}
              </p>
            </template>
          </el-table-column>
          <el-table-column header-align="center" width="80" prop="date" :label="$l('More')">
            <template #default="scope">
              <div class="text-center"><SpIcon type="more" @click="showMore(scope.row)" /></div>
            </template>
          </el-table-column>
        </el-table>
      </sp-card>
    </div>
    <div class="right-side" style="width: 460px; padding: 51px 20px 20px 20px; margin-left: 20px ">
      <el-table
        align="center"
        class="cus-el-table mg-t-20"
        max-height="500"
        :data="dataList"
        style="width: 100%"
        :row-style="setTdHei"
        row-key="id"
        border
      >
        <el-table-column header-align="center" min-width="160" prop="date" :label="$l('ReceiptDate')">
          <template #default="scope">
            <p class="ellipsis-3 item-p label sp-color-11 text-center">
              {{ getDateToFormatEn(scope.row.validAt) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" prop="date" min-width="160" :label="$l('ExpiryDate')">
          <template #default="scope">
            <span class="ellipsis item-p sp-color-11">
              {{ getDateToFormatEn(scope.row.expiredAt) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" width="110" prop="date" :label="$l('Action')">
          <template #default="scope">
            <el-checkbox class="comp-radio" :disabled="!moment(scope.row.expiredAt).isAfter(moment())" :label="1" @change="responseOffer(scope.row)">
              <span style="position:relative; top: 2px">{{ $l('Accept') }}</span>
            </el-checkbox>
            <el-checkbox class="comp-radio mg-t-10" :label="0" :disabled="!moment(scope.row.expiredAt).isAfter(moment())" @click="responseOffer(scope.row, 'reject')">
              <span style="position:relative; top: 2px">{{ $l('Decline') }}</span>
            </el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <SpDrawer v-model="showMoreModel" :width="0.9" :offset-top="20">
      <ExperienceMore :id="offerDetail.id" :info="offerDetail" />
    </SpDrawer>
  </div>
</template>

<script type="text/ecmascript-6">
import { getOfferDetailAPI, getOfferListJob, offerRejectApi, offerAcceptApi } from '@/request/APIs/natural'
import spCard from '@/components/common/SpCard'
import spButton from '@/components/common/SpButton'
import spTable from '@/components/common/SpTableDIY/SpTable'
import SpTableColumn from '@/components/common/SpTableDIY/SpTableColumn'
import SpIcon from '@/components/common/SpIcon'
import { getDateToFormatEn } from '@/utils/convert'
import { reactive, ref } from 'vue'
import ExperienceMore from '@/components/natural/personalProfile/ExperienceMore'
import SpDrawer from '@/components/common/SpDrawer'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import { nextTick } from '@vue/runtime-core'
import moment from 'moment'
import SpMessage from '@/components/common/SpMessage'
export default {
  name: 'NewOffer',

  nameSpace: 'natural.personalProfile.NewOffer',
  components: {
    SpDrawer,
    ExperienceMore,
    SpIcon,
    SpTableColumn,
    spCard,
    spButton,
    spTable,
    spRadioGroup,
    spRadio
  },

  props: {
  },

  setup () {
    // 获取公司数据

    const paramsInfo = reactive({
      page: 1
    })
    const dataList = ref([])
    getOfferListJob().then(res => {
      dataList.value = res.data
    })

    const trigerRefs = ref([])
    const index = ref(0)
    const bindRef = (index, el) => {
      trigerRefs.value[index] = el
    }
    const showMoreModel = ref(false)
    const offerDetail = ref({})
    const showMore = (row) => {
      showMoreModel.value = true
      offerDetail.value = {}
      offerDetail.value = row
    }
    const setTdHei = (row, index) => {
      return 'height:90px'
    }
    const responseOffer = (row, type) => {
      let api = offerAcceptApi
      if (type === 'reject') {
        api = offerRejectApi
      }
      api(row.id, row.employerId).then(res => {
        if (res.code > 0) {
          SpMessage({
            message: res.message,
            type: 'success'
          })
          getOfferListJob().then(res => {
            dataList.value = res.data
          })
          window.location.reload()
        }
      })
    }
    return {
      dataList,
      showMore,
      getDateToFormatEn,
      showMoreModel,
      trigerRefs,
      offerDetail,
      index,
      bindRef,
      paramsInfo,
      setTdHei,
      moment,
      responseOffer
    }
  }
}
</script>

<style scoped lang="less">
.Experience{
  .item-p{
    margin: 0;
    font-size: 16px;
  }
  position:relative;
  width:100%;
  .left-side{
    .table{
      font-weight: bold;
      color: black;
      margin-top: @gap;
      .column{
        .content{
          color: #010101;
          line-height: 4px;
          .desc{
            font-weight: 400;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .right-side{
    background-color: white;
    //padding: 74px @gap @gap @gap;
  }
}
</style>
